// pip pages have race condition with @@COLLECTION-LIST-VIEW/LOAD
// on pip if an item has a collection and
// @@COLLECTION-LIST-VIEW/LOAD has fired
// initilize ddo
// otherwise it ewaits for data via @@COLLECTION-LIST-VIEW/READY then loads ddo
// @@COLLECTION-LIST-VIEW/READY

/* eslint-disable */
// old hdhomelogic
/*

import digitalData from 'digital-data';
import * as pageData from './page-data';
import PipSku from '../__mocks__/pip-sku-mock.json';
import searchData from '../__mocks__/browseAndSearch-search-mock.json';
import plpData from '../__mocks__/browseAndSearch-plp-mock.json';
import categoryData from '../__mocks__/browseAndSearch-category-mock.json';

let previousLocationEvent;

function shouldFirePageview({ locationEvent }) {
  if (!previousLocationEvent) return true;
  const previousPath = previousLocationEvent.location.pathname;
  const path = locationEvent.location.pathname;

  if (/^\/s/.test(previousPath)) return false;
  if (/^\/b/.test(previousPath) && !(/^\/pep/.test(path))) return false;
  if (/^\/pep/.test(previousPath) && /^\/pep/.test(path)) return false;

  return true;
}

function pageHandler(output) {
  window.THD_EVENT_BUS.off('@@HDHOME/PAGE_LOAD', pageHandler);
  const { pageType, response, visualNavPromos, storeId, locationEvent } = output;
  const sskuInteraction = locationEvent
    && locationEvent.location
    && locationEvent.location.state
    && locationEvent.location.state.placement
    && (locationEvent.location.state.placement === 'swatch');

  if (response) {
    switch (pageType) {
      case 'Collection': {
        pageData.setCollectionPageData({ data: response, storeId });
        break;
      }
      case 'PIP': {
        pageData.setPipPageData({ data: { ...response, sskuInteraction } });
        break;
      }
      case 'PEP': {
        if (shouldFirePageview({ locationEvent })) {
          pageData.setPepPageData({ data: response, storeId, sortOption: output.sortOption });
        }
        break;
      }
      case 'Search': {
        if (shouldFirePageview({ locationEvent })) {
          pageData.setSearchPageData({ data: { ...response, visualNavPromos }, storeId });
        }
        break;
      }
      case 'Browse': {
        if (shouldFirePageview({ locationEvent })) {
          pageData.setBrowsePageData({ data: { ...response, visualNavPromos }, storeId });
        }
        break;
      }
      case 'Error': {
        pageData.setErrorPage({ data: response });
        break;
      }
      default: {
        break;
      }
    }
  }
  previousLocationEvent = {
    ...output.locationEvent
  };
}

function locationHandler(locationOutput) {
  window.THD_EVENT_BUS.once('@@HDHOME/PAGE_LOAD', ({ output }) => {
    pageHandler({
      locationEvent: { ...locationOutput.output },
      ...output
    });
  });
}

export default {
  '@@HDHOME/APP_LOAD': (output) => {
    window.THD_EVENT_BUS.on('@@HDHOME/LOCATION_CHANGE', locationHandler);
  }
};

 */
import { PIP } from '../constants';
import { pip } from './pages/pip/pip';
import { pep } from './pages/pep/pep';
import { browseAndCategory } from './pages/browseAndCategory/browseAndCategory';
import { search } from './pages/search/search';
import { collections } from './pages/collections/collections';
import { packages } from './pages/packages/packages';

const { fork, cancel, take } = LIFE_CYCLE_EVENT_BUS.effects;

export const page = () => {

  browseAndCategory();
  pep();
  search();
  collections();
  packages();

  window.LIFE_CYCLE_EVENT_BUS.runEventSequence(function* pipPage() {
    let handler;
    while (true) {
      try {
        const response = yield take('thd-analytics.router-change');
        // @todo determine if we need to cancel
        if (handler) {
          cancel(handler);
        }
        if (response.output.pageType === PIP) {
            handler = yield fork(pip, response);
        }
      } catch (err) {
        console.log(err);
      }
    }
  });
};
